export enum MapRouteFilter {
  ACTIVE_ORDERS = 'activeOrders',
  LAST_7_DAYS = 'last7Days',
  LAST_14_DAYS = 'last14Days',
  LAST_30_DAYS = 'last30Days',
  WHOLE_HISTORY = 'wholeHistory',
}
